import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { SectorDistribution } from '../../models/Common';
import { Utilities } from '../../utility/utils';
import { LeoImagesSectorsPath } from '../../resources/api-constants';
import { useTranslation } from 'react-i18next';

export interface IFundAllocationBubblesProps {
    values: SectorDistribution[];
}

const FundAllocationBubbles: React.FC<IFundAllocationBubblesProps> = ({ values }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();

    let sortedValues = [...values];
    sortedValues.sort((a, b) => b.proportion - a.proportion);
    sortedValues = sortedValues.slice(0, 3);
    const height = 200;
    const width = 350;
    const radius = [68, 48, 53];
    const coords = [{ x: -106, y: 20 }, { x: 116, y: 30 }, { x: 20, y: -20 }];
    const alreadyConsumed = sortedValues.reduce((a, b) => a + b.proportion, 0);
    const leftover = 1 - alreadyConsumed;

    return <><svg width={"100%"} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform={`translate(${width / 2}, ${height / 2})`}>
            {sortedValues.map((v, i) => <g key={`bubble-${v.sector}`}>
                <circle cx={coords[i].x} cy={coords[i].y} r={radius[i]} className={`sector-tag ${Utilities.toClassName(v.sector)}`} />
                <foreignObject width={"80px"} height={"80px"} x={coords[i].x - 40} y={coords[i].y - 40}>
                    <Box display={"flex"} flexDirection={"column"} width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"center"} gap={i===0 ? "16px": "8px"}>
                        <img src={`${LeoImagesSectorsPath}/${v.icon}`} style={{ width: "26px", height: "auto", transform: `scale(${i===0? "1.3" : "1"}` }} alt={`${t('A11ySectorAlt')} ${v.sector}`}/>
                        <Box display={"flex"} padding={"1px 5px"} justifyContent={"center"} alignItems={"center"} bgcolor={theme.palette.common.black} borderRadius={"10px"}>
                            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"500"} color={theme.palette.common.white}>{`${Math.floor(100 * v.proportion)}%`}</Typography>
                        </Box>
                    </Box>
                </foreignObject>
            </g>)}
        </g>
    </svg>
        <Box display={"flex"} width={"100%"} flexWrap={'wrap'} gap={"16px"}>
            {sortedValues.map((v) =>
                <Box key={`legend-${v.sector}`} display={"flex"} flexBasis={"140px"} flexGrow={1} alignItems={"center"} gap={"12px"}>
                    <Box className={`sector-tag ${Utilities.toClassName(v.sector)}`} width={"14px"} height={"14px"} borderRadius={"50%"} flexShrink={0}></Box>
                    <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"600"} color={theme.palette.leo.tone3}>{v.sector} ({Math.floor(v.proportion * 100)}%)</Typography>
                </Box>)}
            {leftover > 0 && <Box key={`legend-null`} display={"flex"} flexBasis={"140px"} flexGrow={1} alignItems={"center"} gap={"12px"}>
                <Box className={`sector-tag`} width={"14px"} height={"14px"} borderRadius={"50%"} flexShrink={0}></Box>
                <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"600"} color={theme.palette.leo.tone3}>{t('PortfolioDetailsGraphOthers')} ({Math.floor(leftover * 100)}%)</Typography>
            </Box>}
        </Box>
    </>
}

export default FundAllocationBubbles;